import * as React from 'react';

import { isTFEAccessNarrowingForIssuesEnabled } from 'feature-flags';
import { RESOURCE_TYPE_ISSUE, RESOURCE_TYPE_PROJECT } from '@atlassian/help-center-common-component/forge-ui/constants';
import { trackError } from '@atlassian/help-center-common-util/analytics';

import { getMetaFromHTML } from '@atlassian/help-center-common-util/meta';
import { TFECacheContext } from '../tfe-cache-context';
import { AtlassianHelpConfigAccountType } from '../types';
import type { Extension, ExtensionPointModule, ResourceContext } from '../types';

export const useTFExtensionList = ({
    type,
    resourceContext,
}: {
    type: ExtensionPointModule;
    resourceContext?: ResourceContext;
}) => {
    const [extensions, setExtensions] = React.useState<Extension[]>([]);
    const accountType = getMetaFromHTML('ajs-account-type') || AtlassianHelpConfigAccountType.ANONYMOUS;
    const { getExtensionsByType, getExtensionsByTypeV2 } = React.useContext(TFECacheContext);
    React.useEffect(() => {
        if (
            accountType === AtlassianHelpConfigAccountType.ATLASSIAN ||
            accountType === AtlassianHelpConfigAccountType.ANONYMOUS ||
            accountType === AtlassianHelpConfigAccountType.CUSTOMER
        ) {
            const { resourceType } = resourceContext || {};
            if (
                isTFEAccessNarrowingForIssuesEnabled() &&
                (resourceType === RESOURCE_TYPE_ISSUE || resourceType === RESOURCE_TYPE_PROJECT)
            ) {
                getExtensionsByTypeV2(type, resourceContext)
                    .then((fetchedExtensions) => {
                        setExtensions(fetchedExtensions[type]);
                    })
                    .catch((e) => {
                        trackError('forge-tfe.setState.failed', {}, e);
                    });
            } else {
                getExtensionsByType(type)
                    .then((fetchedExtensions) => {
                        setExtensions(fetchedExtensions[type]);
                    })
                    .catch((e) => {
                        trackError('forge-tfe.setState.failed', {}, e);
                    });
            }
        }
    }, [accountType, getExtensionsByType, getExtensionsByTypeV2, type, resourceContext]);

    return {
        extensions,
    };
};
